export const columns = function () {
  // 内保单号，机构名称，车牌号，内保起期，内保止期，申请创建日期，延期起期，延期止期，审核人，审核时间，备注
  return [
	{
		prop: "bh",
		label: "内保单号",
		minWidth: 100,
	},
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 100,
    },
    {
      prop: "carNo",
      label: "车牌号",
      minWidth: 100,
    },
    {
      prop: "beginTime",
      label: "内保起期",
      minWidth: 100,
    },
    {
      prop: "endTime",
      label: "内保止期",
      minWidth: 100,
    },
	{
	  prop: "delay_create_time",
	  label: "申请创建日期",
	  minWidth: 100,
	},
	{
	  prop: "delayStartTime",
	  label: "延期起期",
	  minWidth: 100,
	},
	{
	  prop: "delayEndTime",
	  label: "延期止期",
	  minWidth: 100,
	},
	// {
	//   prop: "endTime",
	//   label: "审核人",
	//   minWidth: 100,
	// },
	// {
	//   prop: "endTime",
	//   label: "审核时间",
	//   minWidth: 100,
	// },
	// {
	//   prop: "endTime",
	//   label: "备注",
	//   minWidth: 100,
	// },
  ];
};

export default {};
